import { Component, computed, effect, inject, input } from '@angular/core';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { CheckBoxCompiledComponent } from '../CheckBox/checkbox-compiled';
import { ComboBoxCompiledComponent } from '../ComboBox/combobox-compiled';
import { DatePickerCompiledComponent } from '../DatePicker/datepicker-compiled';
import { FileDialogCompiledComponent } from '../FileDialog/filedialog-compiled';
import { NumericUpDownCompiledComponent } from '../NumericUpDown/numericupdown-compiled';
import { RadioButtonCompiledComponent } from '../RadioButton/radiobutton-compiled';
import { MultiRadioButtonCompiledComponent } from '../MultiRadioButton/multi-radiobutton-compiled';
import { MultiplierRadioButtonCompiledComponent } from '../MultiplierRadioButton/multiplier-radiobutton-compiled';
import { StaticTextCompiledComponent } from '../StaticText/staticitext-compiled';
import { TextBoxCompiledComponent } from '../TextBox/textbox-compiled';
import {
  COMPILED_ELEMENT_EVALUATION_PROVIDER,
  EvaluationScoreComponent,
} from './evaluation-score.component';

@Component({
  selector: 'lib-base-element-compiled',
  template: `
    @let widget = widgetService.widget();
    @if (widgetService.visible()) {
      @if (widget) {
        @switch (widget._mappedType) {
          @case ('TextBox') {
            <lib-textbox-compiled></lib-textbox-compiled>
          }
          @case ('NumericUpDown') {
            <lib-numericupdown-compiled></lib-numericupdown-compiled>
          }
          @case ('DatePicker') {
            <lib-datepicker-compiled></lib-datepicker-compiled>
          }
          @case ('ComboBox') {
            <lib-combobox-compiled></lib-combobox-compiled>
          }
          @case ('CheckBox') {
            <lib-checkbox-compiled></lib-checkbox-compiled>
          }
          @case ('RadioButton') {
            <lib-radiobutton-compiled></lib-radiobutton-compiled>
          }
          @case ('MultiRadioButton') {
            <lib-multi-radiobutton-compiled></lib-multi-radiobutton-compiled>
          }
          @case ('MultiplierRadioButton') {
            <lib-multiplier-radiobutton-compiled></lib-multiplier-radiobutton-compiled>
          }
          @case ('FileDialog') {
            <lib-filedialog-compiled></lib-filedialog-compiled>
          }
          @case ('StaticText') {
            <lib-statictext-compiled></lib-statictext-compiled>
          }
        }
      }

      @if (evaluationResult(); as r) {
        <!-- result with max score are not influential, as they don't affect the score -->
        @if (r.maxScore > 0) {
          <lib-evaluation-score [result]="r"></lib-evaluation-score>
        }
      }
    }
  `,
  imports: [
    TextBoxCompiledComponent,
    NumericUpDownCompiledComponent,
    DatePickerCompiledComponent,
    ComboBoxCompiledComponent,
    CheckBoxCompiledComponent,
    RadioButtonCompiledComponent,
    MultiRadioButtonCompiledComponent,
    MultiplierRadioButtonCompiledComponent,
    FileDialogCompiledComponent,
    StaticTextCompiledComponent,
    EvaluationScoreComponent,
  ],
  providers: [CompilingWidgetService],
})
export class BaseElementCompiledComponent {
  public widgetService = inject(CompilingWidgetService);
  public evaluationProvider = inject(COMPILED_ELEMENT_EVALUATION_PROVIDER, {
    optional: true,
  });

  widgetId = input.required<string>();

  readonly evaluationResult = computed(() => {
    if (!this.evaluationProvider) {
      return null;
    }

    const widgetId = this.widgetId();
    if (!widgetId) {
      return null;
    }

    return this.evaluationProvider.evaluate(widgetId)();
  });

  constructor() {
    effect(() => (this.widgetService.uniqueId = this.widgetId()));
  }
}
